module.exports = __webpack_public_path__ + "img/illus_wizard_4.b0e78829.png";